import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
import { Button } from './ui/button';

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const [bookingId, setBookingId] = useState('');

  useEffect(() => {
    const storedBookingId = sessionStorage.getItem('pending_booking_id');
    if (storedBookingId) {
      setBookingId(storedBookingId);
      sessionStorage.removeItem('pending_booking_id');
    }
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-orange-50 to-amber-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-2xl p-8 text-center">
        <div className="mb-6">
          <CheckCircle className="w-20 h-20 text-green-500 mx-auto" />
        </div>
        
        <h1 className="text-3xl font-bold text-gray-900 mb-4">
          Payment Successful!
        </h1>
        
        <p className="text-gray-600 mb-6">
          Thank you for your booking with Cape Atlantic Tours. Your payment has been processed successfully.
        </p>

        {bookingId && (
          <div className="bg-amber-50 rounded-lg p-4 mb-6">
            <p className="text-sm text-gray-700">
              <span className="font-semibold">Booking Reference:</span> {bookingId}
            </p>
          </div>
        )}

        <div className="space-y-4 text-left text-sm text-gray-700 mb-6">
          <p>✓ Booking confirmed</p>
          <p>✓ Payment received</p>
          <p>✓ Confirmation email sent</p>
        </div>

        <p className="text-sm text-gray-600 mb-6">
          You will receive a confirmation email with all booking details shortly.
        </p>

        <Button
          onClick={() => navigate('/')}
          className="w-full bg-[#6B0B0B] hover:bg-[#8B1515] text-white py-6 text-lg font-semibold"
        >
          Return to Home
        </Button>
      </div>
    </div>
  );
};

export default PaymentSuccess;
